<template>
  <smd-one-col-layout class="modal-instructions">
    <smd-header slot="header">
      <text-string class="modal-instructions__skip-btn"
                   label-id="txt359"
                   slot="right-actions"
                   @handleClick="skipModal"/>
    </smd-header>
    <div class="text-center m-b-15">
      <text-string class="m-b-30" :label-id="title"/>
      <swiper-container ref="modalInstructionsSwiper"
                        events-prefix="swiper"
                        :space-between="60"
                        :speed="150"
                        @swiperslidechange="checkSwiperIndex">
        <swiper-slide v-for="item in items"
                      :key="item.step">
          <component style="height: 280px"
                     :is="item.component"/>
        </swiper-slide>
      </swiper-container>
    </div>

    <pagination-bubble class="m-b-20"
                       :active-step="activeStep"
                       :steps="steps"/>

    <div slot="bottom-nav">
      <div class="smd-form__row">
        <smd-btn :section="$isDesktop? '10' : '5'"
                 :variant="backBtnVariant"
                 @click="decrementStep">
          <text-string label-id="txt109"/>
        </smd-btn>
        <smd-btn :section="$isDesktop? '10' : '5'"
                 variant="right-blue-enabled"
                 @click="incrementStep">
          <text-string :label-id="nextBtnText"/>
        </smd-btn>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import PaginationBubble from '@/components/pagination-bubble';
  import {register} from 'swiper/swiper-element-bundle.mjs'

  register();

  export default {
    name: "modal-instructions",
    mixins: [CloseModalMixin],
    components: {
      PaginationBubble
    },
    props: {
      items: {type: Array, required: true},
      mainTitle: {type: String},
      proceedTo: {type: String, default: null},
      routeDelay: {type: Boolean, default: false},
      modalLocalStorageKey: {type: String}
    },
    data() {
      return {
        activeStep: 1
      }
    },
    computed: {
      title() {
        const {titleTextString} = this.items.find(({step}) => step === this.activeStep);
        return titleTextString || this.mainTitle;
      },
      activeComponent() {
        return this.items[this.activeComponentIndex].component;
      },
      activeComponentIndex() {
        return this.activeStep - 1;
      },
      backBtnVariant() {
        return this.activeStep === 1 ? 'left-disabled' : 'left-enabled'
      },
      nextBtnText() {
        return this.activeStep !== this.steps ? 'txt349' : 'txt350';
      },
      steps() {
        return this.items.length
      }
    },
    methods: {
      checkSwiperIndex() {
        this.activeStep = this.modalSwiper().swiper.activeIndex + 1;
      },
      decrementStep() {
        this.activeStep !== 1 ? this.activeStep -= 1 : false;
      },
      finishTutorial() {
        if (this.proceedTo)
          this.$router.push({
            name: this.proceedTo
          })
        localStorage.setItem(this.modalLocalStorageKey, '0')
        this.closeModal({success: true});
      },
      incrementStep() {
        this.activeStep !== this.steps ? this.activeStep += 1 : this.finishTutorial();
      },
      modalSwiper() {
        return this.$refs.modalInstructionsSwiper
      },
      skipModal() {
        if (this.proceedTo)
          this.$router.push({
            name: this.proceedTo,
          })
        this.closeModal({success: true});
      },
    },
    watch: {
      activeStep(idx) {
        this.modalSwiper().swiper.slideTo(idx - 1);
      }
    }
  }
</script>

<style scoped>

</style>